import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  outletDetails: {},
};

const outletDetailSlice = createSlice({
  name: "outlet",
  initialState,
  reducers: {
    details: (state, action) => {
      state.outletDetails = action.payload;
    },
  },
});

export default outletDetailSlice.reducer;
export const { details } = outletDetailSlice.actions;
